import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactSlider from "react-slider";
import { getCarsList } from "../../../features/bookings/carrentSlice";
import { getStarsCount } from "../../../features/bookings/hotelSlice";
import "./range.css";

const HotelFilter = ({ filterData, maxp, minp, noRooms, Reset }) => {
  const carsListting = useSelector(getCarsList);
  const getStarCount = useSelector(getStarsCount);
  const [sortBy, setSortBy] = useState("");
  const [currentPrice, setCurrentPrice] = useState();
  const [filterState, setfilterState] = useState({
    PriceSort: [],
    PriceRange: [],
    PriceFilter: [],
    Rating: [],
    NameFilter: "",
    Reset: false,
  });
  var NameTimer = "";
  const FilterHandler = (type, val) => {
    switch (type) {
      case "NameFilter":
        clearTimeout(NameTimer);
        if (val !== "") {
          NameTimer = setTimeout(() => {
            filterState["Reset"] = false;
            filterState[type] = val;
            setfilterState(filterState);
            filterData(filterState);
          }, 800);
        } else {
          NameTimer = setTimeout(() => {
            filterState["Reset"] = false;
            filterState[type] = val;
            setfilterState(filterState);
            filterData(filterState);
          }, 300);
        }
        break;
      case "PriceSort":
        setSortBy(val);
        setTimeout(() => {
          filterState["Reset"] = false;
          filterState[type] = [];
          filterState[type].push(val);
          setfilterState(filterState);
          filterData(filterState);
        }, 500);

        break;
      case "Reset":
        setSortBy("");
        filterState[type] = true;
        filterState["PriceSort"] = [];
        filterState["PriceRange"] = [];
        filterState["PriceFilter"] = [];
        filterState["Rating"] = [];
        filterState["NameFilter"] = "";
        setfilterState(filterState);
        filterData(filterState);
        break;
      case "PriceRange":
        clearTimeout(NameTimer);
        filterState["Reset"] = false;
        filterState["PriceRange"] = [];
        NameTimer = setTimeout(() => {
          val.map((p, i) => {
            filterState["PriceRange"].push(p);
          });
          setfilterState(filterState);
          filterData(filterState);
        }, 1000);
        break;
    }
    // if (type === "Reset") {
    //   filterState[type] = true;
    //   filterState["PriceSort"] = [];
    //   filterState["PriceRange"] = [];
    //   filterState["PriceFilter"] = [];
    //   filterState["Rating"] = [];
    //   filterState["NameFilter"] = "";
    // }

    // if (type === "PriceSort") {
    //   filterState["Reset"] = false;
    //   filterState[type] = [];
    //   filterState[type].push(val);
    // }

    if (
      type !== "PriceSort" &&
      type !== "PriceRange" &&
      type !== "NameFilter" &&
      type !== "Reset"
    ) {
      filterState["Reset"] = false;
      const findss = filterState[type].find((f) => f === val);

      if (findss === undefined) {
        filterState[type] = [...filterState[type], val];
      } else {
        var ind = filterState[type].findIndex((f) => f === val);
        filterState[type].splice(ind, 1);
      }

      setfilterState(filterState);

      filterData(filterState);
    }
  };

  return (
    <>
      <div aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Hotel listing
          </li>
        </ol>
      </div>
      <div className="fillter-container">
      <div className={`filter-wrap`}>
        <div className="filter-title">
          <h4>Sort & Filters</h4>
          <span onClick={() => FilterHandler("Reset", "0")}>Reset</span>
        </div>

        <div className="filter-inner-wrap">
          <div className="applied-filter-wrap"></div>
        </div>
      </div>

      <div className="filter-ctr">
        <div>
          <div className="filter-title">
            <h6 className="list-heading">Search By Name</h6>
          </div>
          <input
            type={"text"}
            placeholder="Search"
            onChange={(e) => {
              FilterHandler("NameFilter", e.target.value);
            }}
          />
        </div>
      </div>

      <div className="filter-ctr">
        <h6 className="list-heading">Sort By</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={sortBy === "MaxToMin" ? "list active" : "list"}
              onClick={() => {
                FilterHandler("PriceSort", "MaxToMin");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/high-to-low.svg" alt="" />
              </div>
              <div className="text">High to Low</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={sortBy === "MinToMax" ? "list active" : "list"}
              onClick={() => {
                FilterHandler("PriceSort", "MinToMax");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/low-to-high.svg" alt="" />
              </div>
              <div className="text">Low to High</div>
            </div>
          </div>
        </div>
      </div>

      <div className="filter-ctr price-range-main">
        <h6 className="list-heading">Price</h6>
        {maxp > 0 ? (
          <ReactSlider
            className="horizontal-slider"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            defaultValue={[minp, maxp]}
            min={parseInt(minp)}
            max={parseInt(maxp + 20)}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={100}
            onChange={([min, max]) => {
              FilterHandler("PriceRange", [min, max]);
            }}
          />
        ) : (
          ""
        )}

        <div className="range-display">{currentPrice}</div>
      </div>

      <div className="filter-ctr star-category">
        <h6 className="list-heading">Star Category</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["Rating"].includes("1") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Rating", "1");
              }}
            >
              <div className="d-flex align-items-center">
                <div className="filter-icons-wrap">
                  <img src="/assets/images/hotel/star.svg" alt="" />
                </div>
              </div>
              <div>
                <div className="text">({getStarCount.onestar})</div>
              </div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["Rating"].includes("2") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Rating", "2");
              }}
            >
              <div className="d-flex align-items-center">
                <div className="filter-icons-wrap">
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                </div>
              </div>
              <div>
                <div className="text">({getStarCount.twostar})</div>
              </div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["Rating"].includes("3") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Rating", "3");
              }}
            >
              <div className="d-flex align-items-center">
                <div className="filter-icons-wrap">
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                </div>
              </div>
              <div>
                <div className="text">({getStarCount.threestar})</div>
              </div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["Rating"].includes("4") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Rating", "4");
              }}
            >
              <div className="d-flex align-items-center">
                <div className="filter-icons-wrap">
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                </div>
              </div>
              <div>
                <div className="text">({getStarCount.fourstar})</div>
              </div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["Rating"].includes("5") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Rating", "5");
              }}
            >
              <div className="d-flex align-items-center">
                <div className="filter-icons-wrap">
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                  <img src="/assets/images/hotel/star.svg" alt="" />
                </div>
              </div>
              <div>
                <div className="text">({getStarCount.fivestar})</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          noRooms
            ? "filter-ctr filter-disable star-category"
            : "filter-ctr star-category"
        }
      >
        <h6 className="list-heading">Price (per night)</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["PriceFilter"].includes("0-100")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceFilter", "0-100");
              }}
            >
              <div className="text">₹0 - ₹100</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["PriceFilter"].includes("100-200")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceFilter", "100-200");
              }}
            >
              <div className="text">₹100 - ₹200</div>
            </div>
          </div>

          <div className="list-wrapper">
            <div
              className={
                filterState["PriceFilter"].includes("200-300")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceFilter", "200-300");
              }}
            >
              <div className="text">₹200 - ₹300</div>
            </div>
          </div>

          <div className="list-wrapper">
            <div
              className={
                filterState["PriceFilter"].includes("300-400")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceFilter", "300-400");
              }}
            >
              <div className="text">₹300 - ₹400</div>
            </div>
          </div>

          <div className="list-wrapper">
            <div
              className={
                filterState["PriceFilter"].includes("500")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceFilter", "500");
              }}
            >
              <div className="text">₹500 +</div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default HotelFilter;
